/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Videos_TitleInputs */

const en_settings_videos_title = /** @type {(inputs: Settings_Videos_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My videos`)
};

/**
* | output |
* | --- |
* | "My videos" |
*
* @param {Settings_Videos_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_videos_title = /** @type {((inputs?: Settings_Videos_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Videos_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_videos_title(inputs)
});
export { settings_videos_title as "settings.videos.title" }